export default "__VITE_ASSET__oUhcfI3V__"